import React, { useEffect, useRef, useState } from "react";
import Header from '../Header/Header.js'
import Footer from '../Footer/Footer.js'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import useScrollToTop from '../components/useScrollToTop.js';
import { GoCircle } from "react-icons/go";
import { SlLocationPin } from "react-icons/sl";
import { RiUserLocationLine } from "react-icons/ri";
import Findbikemodels from './Findbikemodels.js';
import { MdDirectionsBike } from "react-icons/md";
import { useMutation } from "@apollo/client";
import { ADD_SAME_DAY_ORDER } from "../graphql/Mutation/SameDayOrder.js";
import { toast } from "react-toastify";
import { API_URL } from "../config.js";
import SpinLoader from "../components/SpinLoader.js";
import { BsShop, BsCart, BsCup, BsCapsule, BsPersonLinesFill, BsGift, BsFolder, BsChatDots } from "react-icons/bs";
import Swal from "sweetalert2";

const categories = [
    { name: "E-commerce & Retail", icon: <BsShop /> }, // Outline for shops/retail
    { name: "Groceries", icon: <BsCart /> }, // Outline for shopping carts
    { name: "Restaurants & Takeaway", icon: <BsCup /> }, // Outline for coffee/restaurants
    { name: "Pharma", icon: <BsCapsule /> }, // Outline for capsules/medicines
    { name: "Fashion and Clothes", icon: <BsPersonLinesFill /> }, // Outline for personal/fashion
    { name: "Flowers & Gifts", icon: <BsGift /> }, // Outline for gifts
    { name: "Offices", icon: <BsFolder /> }, // Outline for office folders
    { name: "Others", icon: <BsChatDots /> }, // Outline for chats/others
];


const cities = [
    { name: "Ahmedabad", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/1.jpg" },
    { name: "Bangalore", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/2.jpg" },
    { name: "Chandigarh", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/3.jpg" },
    { name: "Chennai", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/4.jpg" },
    { name: "Coimbatore", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/5.jpg" },
    { name: "Delhi", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/6.jpg" },
    { name: "Hyderabad", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/7.jpg" },
    { name: "Indore", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/8.jpg" },
    { name: "Jaipur", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/9.jpg" },
    { name: "Kanpur", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/10.jpg" },
    { name: "Kochi", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/11.jpg" },
    { name: "Kolkata", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/12.jpg" },
    { name: "Lucknow", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/13.jpg" },
    { name: "Ludhiana", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/14.jpg" },
    { name: "Mumbai", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/15.jpg" },
    { name: "Nagpur", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/16.jpg" },
    { name: "Nashik", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/17.jpg" },
    { name: "Pune", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/18.jpg" },
    { name: "Surat", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/19.jpg" },
    { name: "Vadodara", image: "https://uklogistics.s3.ap-south-1.amazonaws.com/sameday-city-name/20.jpg" },
];


const SameDay = () => {
    const [price, setPrice] = useState(null);
    const [sameDayOrderData, { loading }] = useMutation(ADD_SAME_DAY_ORDER);
    useScrollToTop();




    const fetchPrice = async () => {
        try {
            let errorMessage = "Please fill all required fields: ";

            if (!pickupLocation?.lat || !pickupLocation?.lng) {
                errorMessage += "Pickup location, ";
            }
            if (!dropoffLocation?.lat || !dropoffLocation?.lng) {
                errorMessage += "Dropoff location, ";
            }
            if (!pickupSenderName) {
                errorMessage += "Sender name, ";
            }
            if (!pickupSenderPhone) {
                errorMessage += "Sender phone, ";
            }
            if (errorMessage.endsWith(", ")) {
                errorMessage = errorMessage.slice(0, -2);
            }

            if (errorMessage !== "Please fill all required fields: ") {
                toast.error(errorMessage);
                return;
            }
            const response = await fetch(`${API_URL}/proxy/get_quote`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    pickup_details: {
                        lat: pickupLocation?.lat,
                        lng: pickupLocation?.lng,
                    },
                    drop_details: {
                        lat: dropoffLocation?.lat,
                        lng: dropoffLocation?.lng,
                    },
                    customer: {
                        name: pickupSenderName,
                        mobile: {
                            country_code: "+91",
                            number: pickupSenderPhone,
                        },
                    },
                }),
            });

            if (!response?.ok) {
                throw new Error(`Error: ${response?.status} - ${response?.statusText}`);
            }

            const data = await response.json();
            // console.log('✌️data ---', data);
            const twoWheeler = data?.vehicles?.find(vehicle => vehicle?.type === "2 Wheeler");

            // if (twoWheeler && twoWheeler?.fare && twoWheeler?.fare.minor_amount) {
            //     const sameGetQuotePrice = (twoWheeler?.fare?.minor_amount / 100).toFixed(2)
            //     setPrice()
            // }
            if (twoWheeler && twoWheeler?.fare && twoWheeler?.fare.minor_amount) {
                const originalPrice = Math.round(twoWheeler?.fare?.minor_amount / 100); // Original price
                const adjustedPrice = (originalPrice * (1 - 0.035)).toFixed(2); // Apply a -3.5% adjustment
                setPrice(adjustedPrice); // Display adjusted price with percentage change
            }

        } catch (error) {
            // console.error("Error fetching price:", error.message);
        }
    };

    const [pickupSenderName, setPickupSenderName] = useState("");
    const [pickupSenderPhone, setPickupSenderPhone] = useState("");
    const [open, setOpen] = useState(true);
    const [dropoffReceiverName, setDropoffReceiverName] = useState("");
    const [dropoffReceiverPhone, setDropoffReceiverPhone] = useState("");
    // console.log('✌️dropoffReceiverPhone --->', dropoffReceiverPhone);
    const [pickupMarker, setPickupMarker] = useState(null);
    const [dropoffMarker, setDropoffMarker] = useState(null);
    const mapRef = useRef(null); // Reference to the map container
    const [map, setMap] = useState(null); // Map instance
    const [pickupLocation, setPickupLocation] = useState(null);
    // console.log('✌️pickupLocation --->', pickupLocation);
    const [dropoffLocation, setDropoffLocation] = useState(null);
    // console.log('✌️dropoffLocation --->', dropoffLocation);

    const [showData, setShowData] = useState();
    const [ReceiverApartmentAddress, setReceiverApartmentAddress] = useState("");
    // console.log('✌️ReceiverApartmentAddress --->', ReceiverApartmentAddress);
    const [PickupApartmentAddress, setPickupApartmentAddress] = useState("");
    // console.log('✌️PickupApartmentAddress --->', PickupApartmentAddress);
    const autoCompleteRefs = useRef({ pickup: null, dropoff: null }); // Autocomplete instances
    const directionsRenderer = useRef(null);
    const [pickupAddress, setPickupAddress] = useState("");
    // console.log('✌️pickupAddress --->', pickupAddress);
    const [pickupLatLng, setPickupLatLng] = useState({ lat: null, lng: null });
    // console.log('✌️pickupLatLng --->', pickupLatLng);
    const [dropoffAddress, setDropoffAddress] = useState("");
    // console.log('✌️dropoffAddress --->', dropoffAddress);
    const [dropoffLatLng, setDropoffLatLng] = useState({ lat: null, lng: null });
    // console.log('✌️dropoffLatLng --->', dropoffLatLng);
    const googleMapsApiKey = "AIzaSyDpEuwbvnz8Aokf6wuwNBBi9kilDW6AJQA";

    const initializeMap = () => {
        const center = { lat: 19.074820158286663, lng: 72.88340888062348 }; // Default center
        const map = new window.google.maps.Map(mapRef.current, {
            center,
            zoom: 12,
        });
        setMap(map);
        directionsRenderer.current = new window.google.maps.DirectionsRenderer();
        directionsRenderer.current.setMap(map);
    };

    // Autocomplete: Initialize Places Autocomplete
    const initializeAutocomplete = (type) => {
        const input = document.getElementById(`${type}-address`);
        const autocomplete = new window.google.maps.places.Autocomplete(input);
        autoCompleteRefs.current[type] = autocomplete;

        autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            if (place.geometry) {
                const position = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                };
                if (type === "pickup") {
                    setPickupAddress(place.formatted_address);
                    setPickupLocation(position);
                } else {
                    setDropoffAddress(place.formatted_address);
                    setDropoffLocation(position);
                }
            }
        });
    };

    // Draw route between pickup and dropoff
    const drawRoute = () => {
        if (pickupLocation && dropoffLocation) {
            const directionsService = new window.google.maps.DirectionsService();
            const request = {
                origin: pickupLocation,
                destination: dropoffLocation,
                travelMode: window.google.maps.TravelMode.DRIVING,
            };

            directionsService.route(request, (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    directionsRenderer.current.setDirections(result);
                } else {
                    // console.error("Directions request failed due to: " + status);
                }
            });
        }
    };

    // Load the Google Maps script dynamically
    const loadGoogleMapsScript = () => {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places`;
        script.async = true;
        script.onload = () => {
            initializeMap();
            initializeAutocomplete("pickup");
            initializeAutocomplete("dropoff");
        };
        document.body.appendChild(script);
    };

    useEffect(() => {
        loadGoogleMapsScript();
    }, []);

    // Trigger route drawing when locations are set
    useEffect(() => {
        drawRoute();
    }, [pickupLocation, dropoffLocation]);



    const getCurrentLocation = async (type) => {
        if (!navigator.geolocation) {
            alert("Geolocation is not supported by your browser.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                const address = await geocodeLatLng(lat, lng);
                // console.log('✌️address --->', address);

                const location = { lat, lng };
                if (type === "pickup") {
                    setPickupLocation(location);
                    setPickupAddress(address);
                    addMarker(location, "pickup");
                } else {
                    setDropoffLocation(location);
                    setDropoffAddress(address);
                    addMarker(location, "dropoff");
                }

                // console.log(`Current ${type} Location:`, address);
            },
            (error) => {
                console.error("Error fetching current location:", error);
            }
        );
    };

    const addMarker = (position, type) => {
        const label = type === "pickup" ? "P" : "D";  // Label for Pickup ("P") or Dropoff ("D")

        const marker = new window.google.maps.Marker({
            position,
            map,
            draggable: true,
            label: label,  // Set the label here
        });

        marker.addListener("dragend", async () => {
            const lat = marker.getPosition().lat();
            const lng = marker.getPosition().lng();
            const address = await geocodeLatLng(lat, lng);
            if (type === "pickup") {
                setPickupMarker(marker);
                // console.log("Pickup Address:", address);
            } else {
                setDropoffMarker(marker);
                // console.log("Dropoff Address:", address);
            }
        });

        if (type === "pickup") setPickupMarker(marker);
        else setDropoffMarker(marker);
    };

    // Trigger route drawing when locations are set
    useEffect(() => {
        drawRoute();
    }, [pickupLocation, dropoffLocation]);

    const geocodeLatLng = async (lat, lng) => {
        // console.log('✌️lat, lng --->', lat, lng);
        const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${googleMapsApiKey}`;
        const response = await fetch(geocodeUrl);
        // console.log('✌️response --->', response);
        const data = await response.json();
        // console.log('✌️data --->', data);
        if (data.results && data.results.length > 0) {
            return data.results[0].formatted_address;
        }
        return "Address not found";
    };

    const adjustBounds = () => {
        const bounds = new window.google.maps.LatLngBounds();

        if (pickupMarker) bounds.extend(pickupMarker.getPosition());
        if (dropoffMarker) bounds.extend(dropoffMarker.getPosition());

        map.fitBounds(bounds);
    };
    const handleFieldClick = (type) => {
        // Default position for marker if no location exists yet
        const defaultPosition = map.getCenter().toJSON();

        if (type === "pickup" && !pickupMarker) {
            addMarker(defaultPosition, "pickup");
            // setPickupAddress("Dragging to select...");
        }

        if (type === "dropoff" && !dropoffMarker) {
            addMarker(defaultPosition, "dropoff");
            // setDropoffAddress("Dragging to select...");
        }
    };

    const formik = useFormik({
        initialValues: {
            pickupAddress: "",
            pickupSenderName: "",
            pickupSenderPhone: "",
            dropoffAddress: "",
            dropoffReceiverName: "",
            dropoffReceiverPhone: "",
        },

        // validationSchema,
        onSubmit: async (values) => {
            // Swal.fire({
            //     title: "Are You Sure You Want to Cancel Your Courier and Not Find Driver?",
            //     html: `<p class="swal-professional-text">
            //     Are you sure you want to cancel your courier? Once cancelled, the assigned driver will be unlinked, 
            //     and the delivery process will stop immediately. If you’re certain, please click the 'Cancel Courier' 
            //     button below to confirm your cancellation. Alternatively, if you wish to proceed with the delivery, 
            //     simply close this message or click 'Find Driver' to reassign a driver and continue with the delivery process. 
            //     If you have any questions, feel free to contact us for assistance.
            //   </p>`,
            //     icon: "warning",
            //     showCancelButton: true,
            //     confirmButtonColor: "#1F2937",  // Dark gray color for a professional feel
            //     cancelButtonColor: "#B8B8B8",   // Lighter color for the cancel button
            //     confirmButtonText: "Yes, cancel it!",
            //     cancelButtonText: "No, keep it",
            //     customClass: {
            //         title: "swal-professional-title",
            //         text: "swal-professional-text",
            //         confirmButton: "swal-professional-button",
            //         cancelButton: "swal-professional-button",
            //         icon: "swal-professional-icon"
            //     },
            //     backdrop: true,
            //     // padding: '30px',
            //     showClass: {
            //         popup: 'animate__animated animate__zoomIn',
            //     },
            //     hideClass: {
            //         popup: 'animate__animated animate__zoomOut',
            //     }
            // // }).then((result) => {
            // //     if (result.isConfirmed) {
            // //         Swal.fire({
            // //             title: "Deleted!",
            // //             text: "Your file has been deleted.",
            // //             icon: "success",
            // //             confirmButtonColor: "#10B981", // Green color for success button
            // //             customClass: {
            // //                 title: "swal-professional-title",
            // //                 content: "swal-professional-content",
            // //                 confirmButton: "swal-professional-button"
            // //             }
            // //         });
            // //     }
            // });

            // console.log('✌️values --->', values);

            if (!pickupAddress) {
                toast.error("Pickup address is required.");
                return;
            }
            if (!PickupApartmentAddress) {
                toast.error("Pickup apartment address is required.");
                return;
            }
            if (!pickupLocation?.lat || !pickupLocation?.lng) {
                toast.error("Pickup location (latitude and longitude) is required.");
                return;
            }
            if (!pickupSenderName) {
                toast.error("Pickup sender name is required.");
                return;
            }
            if (!pickupSenderPhone) {
                toast.error("Pickup sender phone number is required.");
                return;
            }

            if (!dropoffAddress) {
                toast.error("Dropoff address is required.");
                return;
            }
            if (!ReceiverApartmentAddress) {
                toast.error("Receiver apartment address is required.");
                return;
            }
            if (!dropoffLocation?.lat || !dropoffLocation?.lng) {
                toast.error("Dropoff location (latitude and longitude) is required.");
                return;
            }
            if (!dropoffReceiverName) {
                toast.error("Dropoff receiver name is required.");
                return;
            }
            if (!dropoffReceiverPhone) {
                toast.error("Dropoff receiver phone number is required.");
                return;
            }
            const sentdata = {

                "request_id": `${Date.now().toString(36)}`,
                "delivery_instructions": {
                    "instructions_list": [
                        {
                            "type": "text",
                            "description": "handle with care",
                        },
                    ],
                },
                "pickup_details": {
                    "address": {
                        "apartment_address": PickupApartmentAddress,
                        "street_address1": pickupAddress,
                        // landmark: "Pickup Landmark",
                        // city: "Bengaluru",
                        // state: "Karnataka",
                        // pincode: "560029",
                        // country: "India",
                        "lat": pickupLocation?.lat,
                        "lng": pickupLocation?.lng,
                        "contact_details": {
                            "name": pickupSenderName,
                            "phone_number": pickupSenderPhone,
                        },
                    },
                },
                "drop_details": {
                    "address": {
                        "apartment_address": ReceiverApartmentAddress,
                        "street_address1": dropoffAddress,
                        // landmark: "Dropoff Landmark",
                        // city: "Bengaluru",
                        // state: "Karnataka",
                        // pincode: "560029",
                        // country: "India",
                        "lat": dropoffLocation.lat,
                        "lng": dropoffLocation.lng,
                        "contact_details": {
                            "name": dropoffReceiverName,
                            "phone_number": dropoffReceiverPhone,
                        },
                    },
                },
                "additional_comments": "handle with care",
            };

            try {
                const { data } = await sameDayOrderData({
                    variables: {
                        input: {
                            data: sentdata
                        }
                    }
                });
                if (data) {
                    // console.log('✌️data ---+++++++++>', data);
                    setShowData(data);
                    setOpen(true)
                    // setPickupApartmentAddress("")
                    setPickupApartmentAddress("");
                    setPickupAddress("");
                    setDropoffReceiverPhone("");
                    setDropoffAddress("");
                    setPrice(null);
                    setDropoffLocation(null);
                    setReceiverApartmentAddress("");
                    setDropoffReceiverName("");
                    setPickupSenderName("")
                    setPickupSenderPhone("")
                    setPickupLocation(null)

                }
            } catch (err) {
                // console.log('✌️err --->', err);
                toast.error(err.message)

            }
        },
    });
    return (
        <div>
            <Header />
            {/* <Findbikemodels showData={showData} open={open} setOpen={setOpen} /> */}

            {showData && <Findbikemodels showData={showData} open={open} setOpen={setOpen} />}

            <div className="relative isolate overflow-hidden bg-slate-900 py-16 sm:pt-14">
                <img
                    src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/tailwindimg.avif"
                    alt=""
                    className="absolute inset-0 -z-10 h-full w-full object-cover object-right md:object-center"
                />
                <div
                    className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
                    aria-hidden="true"
                >
                    <div
                        className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
                <div
                    className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
                    aria-hidden="true"
                >
                    <div
                        className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
                <div className="mx-auto  max-w-auto md:px-8 lg:px-8">
                    <div className='flex flex-col lg:flex-row lg:space-x-3 gap-y-10'>

                        <div className="w-full lg:w-1/3 bg-white p-6 md:rounded-r-lg shadow-md mt-6 lg:mt-0 relative">
                            <h1 className="text-lg font-bold text-gray-800  mb-4">
                                <MdDirectionsBike className="text-3xl" />Instant Intra-City Pickup and Delivery via  <span className="text-indigo-600">Two-Wheeler Bikes</span>
                            </h1>
                            <form onSubmit={formik.handleSubmit} className="flex mt-7 space-x-4">
                                <div className="space-y-1 text-gray-400">
                                    <GoCircle />
                                    <ul className="ms-1.5">
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                        <li className="text-xs leading-3">I</li>
                                    </ul>
                                    <SlLocationPin />
                                </div>
                                <div className=" flex-initial w-full text-ellipsis overflow-hidden">
                                    {/* Pickup Address */}
                                    <div className="mb-4">
                                        <label
                                            className="block text-gray-700 text-sm font-semibold mb-3"
                                            htmlFor="pickupAddress"
                                        >
                                            Location (Sender-Pickup) <span className="text-red-500">*</span>
                                        </label>
                                        <div className="relative flex items-center">
                                            {/* <input
                                                id="pickupAddress"
                                                name="pickupAddress"
                                                type="text"
                                                className={`w-full border-2 ${formik.touched.pickupAddress && formik.errors.pickupAddress
                                                    ? 'border-red-500'
                                                    : 'border-slate-400'
                                                    } rounded-lg py-2 pl-3 pr-10 focus:outline-none focus:ring-slate-800 focus:border-slate-800`}
                                                placeholder="Enter Location"
                                                value={formik.values.pickupAddress}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            /> */}

                                            <input
                                                id="pickup-address"
                                                type="text"
                                                value={pickupAddress}
                                                // onClick={() => handleFieldClick("pickup")} // Trigger marker creation
                                                onChange={(e) => setPickupAddress(e.target.value)}
                                                placeholder="Enter Pickup Location"
                                                className={`w-full border-2 ${formik.touched.pickupAddress && formik.errors.pickupAddress
                                                    ? 'border-red-500'
                                                    : 'border-slate-400'
                                                    } rounded-lg py-2 pl-3 pr-10 focus:outline-none focus:ring-slate-800 focus:border-slate-800`}
                                            />
                                            <RiUserLocationLine className="absolute right-3 text-indigo-600 text-xl pointer-events-none font-semibold" />
                                        </div>
                                    </div>

                                    <div>
                                        {/* <label htmlFor="ProductPrice" className="block text-sm font-medium text-gray-700 mb-3">
                                            House / Apartment / Shop (optional)<span className="text-red-500">*</span>
                                        </label> */}
                                        <div className="mt-1 flex rounded-md shadow-sm">
                                            <input
                                                type="text"
                                                id="pickup_apartment_address"
                                                name="pickup_apartment_address"
                                                value={PickupApartmentAddress}
                                                onChange={(e) => {
                                                    // const value = e.target.value;

                                                    // setFieldValue('pickup_apartment_address', value);
                                                    setPickupApartmentAddress(e?.target?.value);

                                                }}
                                                onBlur={formik.handleBlur}
                                                // onWheel={(e) => e.target.blur()}
                                                className="flex-1 block w-full px-3 py-2 border border-slate-500 rounded-md focus:outline-none focus:ring-black focus:border-black sm:text-sm"
                                                placeholder="Enter House / Apartment / Shop (optional)"
                                            />
                                        </div>
                                        {/* <ErrorMessage name="ProductPrice" component="div" className="text-red-500 text-sm mt-2" /> */}
                                    </div>
                                    <div>
                                        {/* <label htmlFor="ProductPrice" className="block text-sm font-medium text-gray-700 mb-3">
                                            Sender's Name<span className="text-red-500">*</span>
                                        </label> */}
                                        <div className="my-4 flex rounded-md shadow-sm">
                                            <input
                                                id="pickupSenderName"
                                                type="text"
                                                name="pickupSenderName"
                                                value={pickupSenderName}
                                                onChange={(e) => setPickupSenderName(e.target.value)}
                                                onBlur={formik.handleBlur}
                                                className="flex-1 block w-full px-3 py-2 border border-slate-500 rounded-md focus:outline-none focus:ring-black focus:border-black sm:text-sm"
                                                placeholder="Enter Sender's Name"
                                            />
                                            {/* {formik.errors.pickupSenderName && formik.touched.pickupSenderName && (
                                                <p className="text-red-500 text-xs mt-1">{formik.errors.pickupSenderName}</p>
                                            )} */}
                                        </div>
                                        {/* <ErrorMessage name="ProductPrice" component="div" className="text-red-500 text-sm mt-2" /> */}
                                    </div>
                                    <div>
                                        {/* <label htmlFor="ProductPrice" className="block text-sm font-medium text-gray-700 mb-3">
                                            Sender's Mobile No.<span className="text-red-500">*</span>
                                        </label> */}
                                        <input
                                            id="pickupSenderPhone"
                                            type="text"
                                            name="pickupSenderPhone"
                                            value={pickupSenderPhone}
                                            onChange={(e) => setPickupSenderPhone(e.target.value)}
                                            onBlur={formik.handleBlur}
                                            className="flex-1 block w-full px-3 py-2 border border-slate-500 rounded-md focus:outline-none focus:ring-black focus:border-black sm:text-sm"
                                            placeholder="Enter Sender's Phone"
                                        />
                                        {/* {formik.errors.pickupSenderPhone && formik.touched.pickupSenderPhone && (
                                            <p className="text-red-500 text-xs mt-1">{formik.errors.pickupSenderPhone}</p>
                                        )} */}
                                        {/* <ErrorMessage name="ProductPrice" component="div" className="text-red-500 text-sm mt-2" /> */}
                                    </div>

                                    {/* Destination */}
                                    <div className="mb-4 mt-7">
                                        <label
                                            className="block text-gray-700 text-sm font-semibold mb-3"
                                            htmlFor="destination"
                                        >
                                            Destination (Receiver-Delivery)<span className="text-red-500">*</span>
                                        </label>
                                        <div className="relative flex items-center">
                                            {/* <input
                                                id="destination"
                                                name="destination"
                                                type="text"
                                                className={`w-full border-2 ${formik.touched.destination && formik.errors.destination
                                                    ? 'border-red-500'
                                                    : 'border-slate-400'
                                                    } rounded-lg py-2 pl-3 pr-10 focus:outline-none focus:ring-slate-800 focus:border-slate-800`}
                                                placeholder="Enter Destination"
                                                value={formik.values.destination}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            /> */}
                                            {/* <input
                                                id="dropoff-address"
                                                type="text"
                                                value={dropoffAddress}
                                                // onClick={() => handleFieldClick("dropoff")} // Trigger marker creation
                                                onChange={(e) => setDropoffAddress(e.target.value)}
                                                placeholder="Enter Destination"
                                                style={{ width: "100%", padding: "8px" }}
                                            />
                                            <SlLocationPin className="absolute right-3 text-lg pointer-events-none font-semibold" /> */}

                                            <input
                                                id="dropoff-address"
                                                type="text"
                                                value={dropoffAddress}
                                                // onClick={() => handleFieldClick("pickup")} // Trigger marker creation
                                                onChange={(e) => setDropoffAddress(e.target.value)}
                                                placeholder="Enter Destination Location"
                                                className={`w-full border-2 ${formik.touched.pickupAddress && formik.errors.pickupAddress
                                                    ? 'border-red-500'
                                                    : 'border-slate-400'
                                                    } rounded-lg py-2 pl-3 pr-10 focus:outline-none focus:ring-slate-800 focus:border-slate-800`}
                                            />
                                            <SlLocationPin className="absolute right-3 text-xl pointer-events-none font-semibold" />
                                        </div>
                                        {/* {formik.touched.destination && formik.errors.destination && (
                                            <p className="text-red-500 text-xs mt-1">
                                                {formik.errors.destination}
                                            </p>
                                        )} */}
                                    </div>

                                    <div>
                                        {/* <label htmlFor="ProductPrice" className="block text-sm font-medium text-gray-700 mb-3">
                                            House / Apartment / Shop (optional)<span className="text-red-500">*</span>
                                        </label> */}
                                        <div className="mt-1 flex rounded-md shadow-sm">
                                            <input
                                                type="text"
                                                id="dropoff_apartment_address"
                                                name="dropoff_apartment_address"
                                                value={ReceiverApartmentAddress}
                                                onChange={(e) => {
                                                    // const value = e.target.value;

                                                    // setFieldValue('dropoff_apartment_address', value);
                                                    setReceiverApartmentAddress(e?.target?.value);

                                                }}
                                                onBlur={formik.handleBlur}
                                                // onWheel={(e) => e.target.blur()}
                                                className="flex-1 block w-full px-3 py-2 border border-slate-500 rounded-md focus:outline-none focus:ring-black focus:border-black sm:text-sm"
                                                placeholder="Enter House / Apartment / Shop (optional)"
                                            />
                                        </div>
                                        {/* <ErrorMessage name="ProductPrice" component="div" className="text-red-500 text-sm mt-2" /> */}
                                    </div>
                                    <div>
                                        {/* <label htmlFor="ProductPrice" className="block text-sm font-medium text-gray-700 mb-3">
                                            Sender's Name<span className="text-red-500">*</span>
                                        </label> */}
                                        <div className="my-4 flex rounded-md shadow-sm">
                                            <input
                                                id="dropoffReceiverName"
                                                type="text"
                                                name="dropoffReceiverName"
                                                value={dropoffReceiverName}
                                                onChange={(e) => setDropoffReceiverName(e?.target?.value)}
                                                onBlur={formik.handleBlur}
                                                className="flex-1 block w-full px-3 py-2 border border-slate-500 rounded-md focus:outline-none focus:ring-black focus:border-black sm:text-sm"
                                                placeholder="Enter Receiver's Name"
                                            />
                                            {/* {formik.errors.dropoffReceiverName && formik.touched.dropoffReceiverName && (
                                                <p className="text-red-500 text-xs mt-1">{formik.errors.dropoffReceiverName}</p>
                                            )} */}
                                        </div>
                                        {/* <ErrorMessage name="ProductPrice" component="div" className="text-red-500 text-sm mt-2" /> */}
                                    </div>
                                    <div>
                                        {/* <label htmlFor="ProductPrice" className="block text-sm font-medium text-gray-700 mb-3">
                                            Sender's Mobile No.<span className="text-red-500">*</span>
                                        </label> */}
                                        <div className="mt-1 mb-2 flex rounded-md shadow-sm">
                                            <input
                                                id="dropoffReceiverPhone"
                                                type="text"
                                                name="dropoffReceiverPhone"
                                                value={dropoffReceiverPhone}
                                                onChange={(e) => setDropoffReceiverPhone(e?.target?.value)}
                                                onBlur={formik.handleBlur}
                                                className="flex-1 block w-full px-3 py-2 border border-slate-500 rounded-md focus:outline-none focus:ring-black focus:border-black sm:text-sm"
                                                placeholder="Enter Receiver's Phone"
                                            />
                                            {/* {formik.errors.dropoffReceiverPhone && formik.touched.dropoffReceiverPhone && (
                                                <p className="text-red-500 text-xs mt-1">{formik.errors.dropoffReceiverPhone}</p>
                                            )} */}
                                        </div>
                                        {/* <ErrorMessage name="ProductPrice" component="div" className="text-red-500 text-sm mt-2" /> */}
                                    </div>

                                    {/* Submit Button */}
                                    {/* <button
                                        type="button"
                                        onClick={fetchPrice}
                                        className="w-full mt-4  bg-slate-800 text-white p-2 rounded-lg hover:bg-slate-900 transition duration-300"
                                    >
                                        {isLoading ? "Fetching Price..." : "Show Price"} {price ? `₹${price}` : ''}
                                    </button> */}

                                    <button
                                        className={`w-full mt-4 p-2 rounded-lg transition duration-300 ${loading ? "bg-slate-800 cursor-not-allowed text-white" : "bg-slate-800 hover:bg-slate-900 text-white"
                                            }`}
                                        type="submit"
                                        disabled={loading}
                                    >
                                        <div className="flex justify-center">
                                            <span className="me-2">Create Order & Find Driver</span> {loading && <SpinLoader className />}
                                        </div>
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="lg:w-2/3 md:rounded-l-lg rounded-none md:py-8 md:px-9 p-6 bg-white ring-1 ring-slate-900/5 shadow-md">
                            {/* <img src={mapimage} className="rounded-xl" alt="Plane" /> */}
                            {/* <div>
                                <button onClick={() => getCurrentLocation("pickup")}>
                                    Use Current Location for Pickup
                                </button>
                                <button onClick={() => getCurrentLocation("dropoff")}>
                                    Use Current Location for Dropoff
                                </button>
                            </div> */}
                            <h1 className="font-semibold mb-4">Navigating the World: A Guide to Locating Places on Maps</h1>
                            <div
                                ref={mapRef}
                                style={{
                                    width: "100%",
                                    height: "500px",
                                    border: "1px solid black",
                                    borderRadius: "8px",
                                    marginTop: "10px",
                                }}
                            ></div>

                            <p className="text-sm mt-4">In today’s fast-paced world, time is money, and businesses and customers alike are increasingly looking for faster and more efficient ways to move goods within cities. This is where Instant Intra-City Pickup and Delivery via Two-Wheeler Bikes comes into play. The innovative solution is designed to cater to the growing demand for quick, reliable, and cost-effective delivery services, especially within urban areas. By leveraging two-wheeler bikes for intra-city transportation, businesses can significantly reduce delivery times, improve operational efficiency, and provide a superior customer experience.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className=" py-10 px-7">
                <header className="mb-10">
                    <h1 className="text-2xl font-semibold text-gray-800 mb-4">We Are Transforming Cities</h1>
                    <p className="text-md leading-7 text-justify">
                        Same-day delivery via bike is revolutionizing the logistics industry by offering fast, efficient, and eco-friendly solutions for both businesses and individuals. This service is designed to cater to urgent delivery needs, ensuring that packages, documents, or small goods reach their destination on the very day they are dispatched.
                    </p>

                    <h2 className="text-lg font-semibold mt-6 mb-1">For Businesses</h2>
                    <p className="text-md leading-7 text-justify">
                        For businesses, same-day bike delivery is a game-changer. It helps eCommerce platforms, restaurants, pharmacies, and local retailers meet customer expectations for swift service. Whether it's delivering food, medicines, or last-minute orders, bike Shipment offer a cost-effective solution for urban areas, navigating through traffic faster than larger vehicles.
                    </p>

                    <h2 className="text-lg font-semibold mt-6 mb-1">For Individuals</h2>
                    <p className="text-md leading-7 text-justify mb-6">
                        For individuals, this service brings convenience and reliability. Whether you need to send an important document, a gift, or any personal item, same-day bike delivery ensures it gets to its destination quickly and safely, saving time and reducing stress.
                    </p>
                </header>

                <main>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
                        {cities.map((city, index) => (
                            <div key={index} className="group relative bg-white rounded-lg border overflow-hidden">
                                <img
                                    src={city.image}
                                    alt={city.name}
                                    className="w-full h-40 object-cover transform group-hover:scale-110 transition-transform duration-300"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-slate-50 text-black text-center py-2">
                                    <span className="text-sm ">{city.name}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </main>
            </div>

            <div className="pb-10 px-7">
                <h1 className="text-lg font-semibold text-gray-800 mb-3">
                    For any type of business, we know how to help
                </h1>
                <h2 className="text-lg font-semibold mt-6 mb-1">Environmentally Friendly</h2>
                <p className="text-md leading-7 text-justify mb-6">
                    Moreover, bike deliveries contribute to a greener planet by reducing carbon emissions, making them an environmentally responsible choice for same-day logistics. With real-time tracking and prompt service, same-day bike delivery combines speed, efficiency, and sustainability to meet the dynamic demands of today's fast-paced world.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
                    {categories.map((category, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center justify-center bg-slate-50 border rounded-lg p-6 cursor-pointer hover:bg-slate-100"
                        >
                            <div className="text-2xl mb-4">{category.icon}</div>
                            <h2 className="text-sm text-gray-700 text-center">
                                {category.name}
                            </h2>
                        </div>
                    ))}
                </div>
            </div>



            <Footer />
        </div>
    )
}

export default SameDay
